// extracted by mini-css-extract-plugin
export default {"icon":"NavigatorTab_icon__guNW0"};